/*eslint-disable */
import moment from 'moment-timezone';
import Cookies from 'js-cookie';
import { phoneRegex, urlRegex } from '../constants/regex';

/**
 * Check if the app is running on localhost
 * @returns {boolean} true if running on localhost
 */
export const isLocalhost = () => {
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]' ||
    hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  );
};

export const convertToUSDateFormat = (date) => {
  const userTimezone = moment.tz.guess();
  return moment.tz(date, userTimezone).format('MM-DD-YYYY');
};
export const getCurrentDate = (date, format = 'YYYY-MM-DD') => {
  const userTimezone = moment.tz.guess(); // Detect user's local timezone
  return moment.tz(date, userTimezone).format(format);
};
// Converts a given date into a formatted string based on the user's local timezone.

export const convertDateToString = (date, format = 'YYYY/MM/DD') => {
  if (!date) return '-'; // You can also return '' or 'N/A' based on UI preference

  const momentDate = moment(date);
  if (!momentDate.isValid()) {
    console.warn('Invalid date in getCurrentDate:', date);
    return '-';
  }

  const userTimezone = moment.tz.guess();
  return moment.tz(momentDate, userTimezone).format(format);
};

// Converts a given date into a more readable format based on the user's local timezone.
export const convertToUserTime = (date, format = 'dddd, MMMM Do') => {
  const userTimezone = moment.tz.guess(); // Detect user's local timezone
  return moment.tz(date, userTimezone).format(format);
};

// Converts a date string in 'YYYY-MM-DD' format to a JavaScript Date object.
export const convertStringToDate = (dateString) => {
  return moment(dateString, 'YYYY-MM-DD').toDate();
};

// Gets the start and end dates of the current week based on the user's local timezone.
export const getCurrentWeek = () => {
  const userTimezone = moment.tz.guess(); // Detect user's local timezone
  const dateFrom = moment.tz(userTimezone).startOf('isoWeek').toDate();
  const dateTo = moment.tz(userTimezone).endOf('isoWeek').toDate();
  return {
    dateFrom,
    dateTo,
  };
};
export const getEnvironment = () => {
  return (window.location.origin || '').toLowerCase();
};

export const checkIfLoggedIn = () => {
  let isLoggedIn = false;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    isLoggedIn = true;
  }
  return isLoggedIn;
};

export const getDomain = () => {
  const { hostname } = window.location;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'localhost';
  }

  const azulDomain = process.env.REACT_APP_DOMAIN_AZUL || '';
  const prodDomain = process.env.REACT_APP_DOMAIN_PROD || '';

  return hostname.endsWith(azulDomain) ? `.${azulDomain}` : `.${prodDomain}`;
};

export const logoutHelper = () => {
  const hostname = window.location.hostname;
  const domain = getDomain();
  const allCookies = Cookies.get();
  Object.keys(allCookies).forEach((cookie) => {
    Cookies.remove(cookie, { path: '/', domain });
  });

  window.location.reload();
};

export const validatePhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber?.replace(/\s+/g, '') ?? '';
  if (!cleaned) return true; // allow empty or whitespace-only input

  return phoneRegex.test(cleaned);
};
export const validateWebsiteUrl = (url) => {
  const trimmedUrl = url?.trim();

  if (!trimmedUrl) return true; // allow empty or whitespace-only input

  return urlRegex.test(trimmedUrl);
};

export const formatNumberUS = (number) => {
  if (number === null || number === undefined || isNaN(number)) {
    return number;
  }
  return Number(number).toLocaleString('en-US');
};

export const allowEditInsights = (communityDetails, loggedInUserData) => {
  return (
    (communityDetails?.userrole?.[0]?.id === loggedInUserData?.id &&
      loggedInUserData?.roleId === 1) ||
    loggedInUserData?.roleId === 2
  );
};

/**
 * Normalizes search text by removing leading/trailing spaces and reducing multiple spaces to one.
 * @param {string} text - The search text to normalize.
 * @returns {string} - The normalized search text.
 */
export const normalizeSearchText = (text = '') => {
  // ✅ allow full clear
  if (text === '') return '';

  // 🔥 remove macOS auto ". " insertion
  text = text.replace(/\. /g, ' ');

  // ❌ block initial space
  text = text.trimStart();

  // ❌ no multiple spaces
  return text.replace(/\s{2,}/g, ' ');
};
